/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOneBaseAodRunsControllerAodRunQueryResponse, GetOneBaseAodRunsControllerAodRunPathParams, GetOneBaseAodRunsControllerAodRunQueryParams } from "../models/GetOneBaseAodRunsControllerAodRun";

export function getGetOneBaseAodRunsControllerAodRunUrl(id: GetOneBaseAodRunsControllerAodRunPathParams["id"]) {
  const res = { method: 'GET', url: `/aod-runs/${id}` as const }
  return res
}

/**
 * @summary Retrieve a single AodRun
 * {@link /aod-runs/:id}
 */
export async function getOneBaseAodRunsControllerAodRun(id: GetOneBaseAodRunsControllerAodRunPathParams["id"], params?: GetOneBaseAodRunsControllerAodRunQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOneBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetOneBaseAodRunsControllerAodRunUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}